(function () {
  'use strict';

  var CONFIG = {
    animationDuration: 450,
    minSectionHeight: 100,
    skipSectionClasses: [
      'shopify-section-group-overlay-group',
      'shopify-section--popup',
    ],
    /* Includi footer come ultima sezione */
    includeFooter: true,
  };

  window.addEventListener('load', function () {
    setTimeout(init, 500);
  });

  function init() {
    var main = document.getElementById('main');
    if (!main) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    /* Filtra sezioni — includi footer se richiesto */
    var sections = Array.from(main.querySelectorAll(':scope > .shopify-section')).filter(function (sec) {
      var cls = sec.className || '';

      /* Salta sempre popup e overlay */
      for (var i = 0; i < CONFIG.skipSectionClasses.length; i++) {
        if (cls.indexOf(CONFIG.skipSectionClasses[i]) !== -1) return false;
      }

      /* Salta sezioni troppo piccole (ticker ~37px) */
      if (sec.getBoundingClientRect().height < CONFIG.minSectionHeight) return false;

      /* Footer: includi o escludi in base a config */
      if (cls.indexOf('shopify-section-group-footer-group') !== -1) {
        return CONFIG.includeFooter;
      }

      return true;
    });

    if (!sections.length) return;

    /* CSS globale */
    var st = document.createElement('style');
    st.textContent =
      'html,body{overflow:hidden!important;height:100%!important;}' +
      '#main{scrollbar-width:none!important;-ms-overflow-style:none!important;}' +
      '#main::-webkit-scrollbar{display:none!important;}';
    document.head.appendChild(st);

    /* Stili main — usa height: 100% invece di 100vh per escludere l'header */
    main.style.height = 'calc(100vh - ' + main.offsetTop + 'px)';
    main.style.overflowY = 'scroll';
    main.style.overflowX = 'hidden';
    main.style.position = 'relative';

    /* Altezza sezioni = viewport - offsetTop del main (esclude header) */
    var secH = window.innerHeight - main.offsetTop;

    sections.forEach(function (s) {
      s.style.height = secH + 'px';
      s.style.minHeight = secH + 'px';
      s.style.maxHeight = secH + 'px';
      s.style.overflow = 'hidden';
      s.style.boxSizing = 'border-box';
    });

    /* Posizioni target */
    function targets() {
      return sections.map(function (s) { return s.offsetTop; });
    }

    /* Animazione */
    var animId = null;
    var locked = false;
    var activeIndex = 0;

    function ease(t) {
      return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2;
    }

    function goTo(idx, force) {
      if (locked && !force) return;
      if (idx < 0) idx = 0;
      if (idx >= sections.length) idx = sections.length - 1;
      if (idx === activeIndex && !force) return;

      locked = true;
      activeIndex = idx;

      var t0 = targets();
      var startTop = main.scrollTop;
      var endTop = t0[idx];
      var dist = endTop - startTop;
      var ts0 = null;

      if (animId) cancelAnimationFrame(animId);

      function step(ts) {
        if (!ts0) ts0 = ts;
        var p = Math.min((ts - ts0) / CONFIG.animationDuration, 1);
        main.scrollTop = startTop + dist * ease(p);
        if (p < 1) {
          animId = requestAnimationFrame(step);
        } else {
          main.scrollTop = endTop;
          animId = null;
          locked = false;
        }
      }
      animId = requestAnimationFrame(step);
    }

    main.scrollTop = 0;

    /* ---- TRACKPAD / WHEEL con rilevamento inerzia ---- */
    /* Tecnica: accumula delta, quando si ferma scatta alla sezione */
    var wheelAccum = 0;
    var wheelTimer = null;
    var wheelLocked = false;
    var WHEEL_THRESHOLD = 30; /* px di delta accumulato per triggerare */

    window.addEventListener('wheel', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (wheelLocked) return;

      wheelAccum += e.deltaY;

      /* Reset timer — aspetta che l'inerzia finisca */
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () {
        wheelAccum = 0;
      }, 150);

      /* Triggera quando supera la soglia */
      if (Math.abs(wheelAccum) >= WHEEL_THRESHOLD) {
        var dir = wheelAccum > 0 ? 1 : -1;
        wheelAccum = 0;
        wheelLocked = true;
        clearTimeout(wheelTimer);
        goTo(activeIndex + dir);
        setTimeout(function () { wheelLocked = false; }, CONFIG.animationDuration + 300);
      }
    }, { passive: false, capture: true });

    /* ---- TOUCH ---- */
    var ty = 0;

    window.addEventListener('touchstart', function (e) {
      ty = e.touches[0].clientY;
    }, { passive: true, capture: true });

    window.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, { passive: false, capture: true });

    window.addEventListener('touchend', function (e) {
      var diff = ty - e.changedTouches[0].clientY;
      if (Math.abs(diff) < 40) return;
      goTo(activeIndex + (diff > 0 ? 1 : -1));
    }, { passive: true, capture: true });

    /* ---- TASTIERA ---- */
    window.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); goTo(activeIndex + 1); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); goTo(activeIndex - 1); }
    });

    /* ---- RESIZE ---- */
    window.addEventListener('resize', function () {
      secH = window.innerHeight - main.offsetTop;
      main.style.height = 'calc(100vh - ' + main.offsetTop + 'px)';
      sections.forEach(function (s) {
        s.style.height = secH + 'px';
        s.style.minHeight = secH + 'px';
        s.style.maxHeight = secH + 'px';
      });
      main.scrollTop = targets()[activeIndex] || 0;
    });

    console.log('[TikTok Scroll] OK — ' + sections.length + ' sezioni. offsetTop main: ' + main.offsetTop + 'px');
  }

})();